import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import EventAllListWrap from './EventAllListWrap';
import { EVENT_LIST_FILTER_OPTION_MODEL } from '../../../store/modules/event/models';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import useExcel from './hook/useExcel';
import useEventAllListUtils from './hook/useEventAllListUtils';
import useEventAllListViewModel from './hook/useEventAllListViewModel';

function EventAllListContainer() {
  const { allEvent } = useSelector((state) => state.event);

  const { setInitialAllEventList, openEventItemListModal } = useEventAllListUtils(allEvent);
  const { getAllList, getEventTagColumnTagList } = useEventAllListViewModel(allEvent);
  const { getExcelDownload } = useExcel(allEvent);

  useEffect(() => {
    getAllList({
      filterOption: EVENT_LIST_FILTER_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
  }, []);

  return (
    <EventAllListWrap
      allEvent={allEvent}
      getList={getAllList}
      getExcelDownload={getExcelDownload}
      openEventItemListModal={openEventItemListModal}
      getEventTagColumnTagList={getEventTagColumnTagList}
      setInitialAllEventList={setInitialAllEventList}
    />
  );
}

export default EventAllListContainer;
